<template>
  <div>
    <i-modal :value="updateSystem" @on-cancel="cancel" @on-ok="ok" class-name="vertical-center-modal">
      <div slot="header" style="text-align:center">
        <h2>修改指标名称</h2>
      </div>
      <div style="text-align:center">
        <i-row style="margin:15px 0 30px 0">
          <i-col span="6">
            <span class="title" style="float:right">新的指标名称：</span>
          </i-col>
          <i-col span="18">
            <span style="width: 200px;display:inline-block">
              <i-input style="float:left;margin-left:8px" v-model="updateSystemName"></i-input>
            </span>
          </i-col>
        </i-row>
      </div>
      <div slot="footer" style="text-align:center">
        <i-button type="primary" size="large" style="width:200px" @click="ok">确认</i-button>
      </div>
    </i-modal>
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      force: "",
      showLoading: false,
      updateSystemName: "",
    }
  },
  props: {
    updateSystem: {
      type: Boolean,
      default: false,
    },
    systemId: {},
    systemParentId: {},
    systemName: {},
    systemPath: {},
    systemTypeName: {},
    systemMetaInfo: {},
  },
  //监听父组件传来的分类名并赋值给新变量
  watch: {
    systemName(newName) {
      this.updateSystemName = newName
    },
  },
  methods: {
    cancel() {
      this.updateSystemName = this.systemName
      this.$emit("cancelUpdateSystem")
    },
    confirmUpdate() {
      this.$emit("confirmUpdate")
    },
    close() {
      this.updateSystemName = this.systemName
      this.$emit("close")
    },
    async ok() {
      console.log("修改的数据为,", this.systemId, this.updateSystemName)
      const self = this
      let xdata = {
        data_id: this.systemId,
        name: this.updateSystemName,
      }
      self.showLoading = true
      try {
        if (this.updateSystemName === "") {
          self.$Message.error("请输入修改后的名称")
          self.showLoading = false
        } else {
          const res = await self.axios({
            method: "post",
            url: self.$store.state.baseurl + "/api/bi/indicator_update",
            params: xdata,
          })
          if (!res) {
            return
          }
          if (res.data.code === 0) {
            console.log("code为0")
            self.confirmUpdate()
            self.showLoading = false
          } else {
            self.$Message.error("操作失败，错误原因：" + res.data.error_message)
            self.showLoading = false
          }
        }
      } catch (error) {
        self.$Message.error("操作失败，错误原因：" + error)
        self.showLoading = false
      }
    },
    isJSON(str) {
      if (typeof str == "string") {
        if (str === "") return true
        try {
          let obj = JSON.parse(str)
          if (typeof obj == "object" && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          this.$Message.error("操作失败，错误原因：" + e)
          return false
        }
      }
      this.$Message.error("操作失败，错误原因：" + "It is not a string!")
    },
  },
}
</script>
<style scoped></style>
